import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"items":_vm.items,"item-text":"text","item-value":"value","hide-details":"auto","outlined":"","label":_vm.$t('Application'),"clearable":""},model:{value:(_vm.applications),callback:function ($$v) {_vm.applications=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"applications"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }